import styled from 'styled-components';

import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import { ReactComponent as IconSlideLeft } from 'asserts/icons/ic_chevron_left.svg';
import { ReactComponent as IconSlideRight } from 'asserts/icons/ic_chevron_right.svg';

interface Props {
  imgs: string[];
}

const SliderDefault = ({ imgs }: Props) => {
  const sliderSetting = {
    dots: false,
    infinite: imgs.length <= 1 ? false : true,
    speed: 500,
    slidesToScroll: 1,
    prevArrow: <IconSlideLeft fill="#fff" />,
    nextArrow: <IconSlideRight fill="#fff" />
  };

  return (
    <SliderDefaultWrapper>
      <Slider {...sliderSetting}>
        {imgs.map((img, index) => (
          <div>
            <img src={`/images/${img}.png`} alt={`slider img${index}`} loading="lazy" />
          </div>
        ))}
      </Slider>
    </SliderDefaultWrapper>
  );
};

export default SliderDefault;

const SliderDefaultWrapper = styled.div`
  .slick-list {
    padding: 0 !important;
  }

  .slick-slide {
    border-radius: 8px;
    img {
      margin: 0 auto;
    }
  }

  & .slick-arrow {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 24px;
    height: 24px;
    padding: 14px;
    border-radius: 32px;
    background-color: #3d3d3d;

    &.slick-disabled {
      opacity: 0;
      cursor: default;
    }
  }

  & .slick-prev {
    left: 72px;
  }

  & .slick-next {
    right: 72px;
  }
`;
